import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import * as en from './en.json';
import * as ru from './ru.json';
import * as ua from './ua.json';
import * as be from './by.json';
import * as pl from './pl.json';
import { Language } from '../shared/constants';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: { ...en },
    },
    ru: {
      translation: { ...en, ...ru },
    },
    ua: {
      translation: { ...en, ...ua },
    },
    be: {
      translation: { ...en, ...be },
    },
    pl: {
      translation: { ...en, ...pl },
    },
  },
  lng: Language.en,
});
